export default __webpack_public_path__ + "static/media/GOOD.13030a7e.png";